module.exports = __webpack_public_path__ + "assets/img/img317.d67fcec2.jpg";